import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import _ from "lodash";
import { fetchFeature } from "GeneralTabAction";
import { fetchAllTickets, fetchStripeCurrency } from "TicketAction";
import { ticketsContentContainerWidth } from "Constants";

import Dasboard from "Ticketdashboard";
import Users from "Users";
import Ticket from "Ticket";
import Coupon from "Coupon";
import Setting from "Setting";
import Salesreport from "Salesreport";
import Payout from "Payout";
import FormBuilder from "FormBuilder";
import BadgeDesign from "BadgeDesign";
import Wizard from "Wizard";
import ProposalWizard from "ProposalWizard";
import ProposalDashboard from "ProposalDashboard";
import ProposalForm from "ProposalForm";
import ProposalReviewer from "ProposalReviewer";
import ProposalFormResponse from "ProposalFormResponse";

import ContentTicketMenu from "./components/common/content-ticket-menu";
import LocaleStrings from "Languages";

class Tickets extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // this.props.fetchAllTickets(this.props.session);
    this.props.fetchFeature(this.props.session);
    this.props.fetchStripeCurrency(this.props.session);
  }

  renderCommonOptionList() {
    return this.props.ticketMenus.map((item, index) => {
      if (item && item.section === "common") {
        return <ContentTicketMenu key={item.iconName} item={item} />;
      }
    });
  }

  renderUsersOptionList() {
    return this.props.ticketMenus.map((item, index) => {
      if (item && item.section === "user") {
        return <ContentTicketMenu key={item.iconName} item={item} />;
      }
    });
  }

  renderTicketOptionList() {
    return this.props.ticketMenus.map((item, index) => {
      if (item && item.section === "ticket") {
        return <ContentTicketMenu key={item.iconName} item={item} />;
      }
    });
  }

  renderProposalOptionList() {
    return this.props.proposalMenus.map((item, index) => {
      if (item && item.section === "proposal") {
        return <ContentTicketMenu key={item.iconName} item={item} />;
      }
    });
  }

  contentAvailable(content) {
    var existingFeature = this.props.selectedFeatures.filter(
      (feature) => feature.label === content
    );
    return existingFeature.length > 0;
  }

  onManageFeatures = () => {};

  render() {
    // This code is used to programmatically merge user with ticket and disable or enable ticket side menu as per conditions.
    let userMenu = [{ isenabled: false }];
    let ticketMenu = [{ isenabled: false }];
    let proposalMenu = [{ isenabled: false }];

    if (this.props.totalAppModules && this.props.totalAppModules.length > 0) {
      userMenu = _.filter(this.props.totalAppModules, (obj) => {
        return obj.bsClass === "users";
      });
      ticketMenu = _.filter(this.props.totalAppModules, (obj) => {
        return obj.bsClass === "tickets";
      });
      proposalMenu = _.filter(this.props.totalAppModules, (obj) => {
        return obj.bsClass === "proposal";
      });
    }
    // =============================== //

    let hrstyle = {
      margin: "0px -16px 15px -16px",
      borderTop: "1px solid #e6edf3",
    };

    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            <div>
              {ticketMenu[0].isenabled ? (
                <ul className="list-group">{this.renderCommonOptionList()}</ul>
              ) : (
                ""
              )}

              {userMenu[0].isenabled ? (
                <div>
                  <div
                    className="custom-text1-primary-medium"
                    style={{ paddingLeft: 10 }}
                  >
                    {LocaleStrings.tickets_submenu_sections_user}
                  </div>
                  <hr style={hrstyle} />
                  <ul className="list-group">{this.renderUsersOptionList()}</ul>
                </div>
              ) : (
                ""
              )}
              {ticketMenu[0].isenabled ? (
                <div>
                  <div
                    className="custom-text1-primary-medium"
                    style={{ paddingLeft: 10 }}
                  >
                    {LocaleStrings.tickets_submenu_sections_ticket}
                  </div>
                  <hr style={hrstyle} />
                  <ul className="list-group">
                    {this.renderTicketOptionList()}
                  </ul>
                </div>
              ) : (
                ""
              )}
              {proposalMenu &&
              proposalMenu.length > 0 &&
              proposalMenu[0].isenabled ? (
                <div>
                  <div
                    className="custom-text1-primary-medium"
                    style={{ paddingLeft: 10 }}
                  >
                    {LocaleStrings.tickets_submenu_sections_proposal}
                  </div>
                  <hr style={hrstyle} />
                  <ul className="list-group">
                    {this.renderProposalOptionList()}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className="content-subcontainer"
            // style={{ width: `${ticketsContentContainerWidth}px` }}
          >
            <Route path="/dashboard/tickets/dashboard" component={Dasboard} />
            {/* <Route path="/dashboard/tickets/appusers" component={Users} /> */}
            <Route
              path="/dashboard/tickets/appusers"
              history={this.props.history}
              component={Users}
            />
            <Route
              path="/dashboard/tickets/managetickets"
              history={this.props.history}
              component={Ticket}
            />
            <Route
              path="/dashboard/tickets/coupons"
              history={this.props.history}
              component={Coupon}
            />
            <Route
              path="/dashboard/tickets/salesreport"
              component={Salesreport}
            />
            <Route
              path="/dashboard/tickets/settings"
              history={this.props.history}
              component={Setting}
            />
            <Route path="/dashboard/tickets/payout" component={Payout} />
            <Route
              path="/dashboard/tickets/formbuilder"
              component={FormBuilder}
            />
            <Route
              path="/dashboard/tickets/badgedesign"
              history={this.props.history}
              component={BadgeDesign}
            />
            <Route
              path="/dashboard/tickets/wizard"
              history={this.props.history}
              component={Wizard}
            />
            <Route
              path="/dashboard/tickets/proposalwizard"
              history={this.props.history}
              component={ProposalWizard}
            />
            <Route
              path="/dashboard/tickets/proposaldashboard"
              component={ProposalDashboard}
              history={this.props.history}
            />
            <Route
              path="/dashboard/tickets/proposalform"
              component={ProposalForm}
            />
            <Route
              path="/dashboard/tickets/proposalreveiwer"
              component={ProposalReviewer}
            />
            <Route
              path="/dashboard/tickets/proposalresponses"
              component={ProposalFormResponse}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ticketMenus: state.ticketMenus,
    proposalMenus: state.proposalMenus,
    session: state.session,
    totalAppModules: state.totalAppModules,
  };
}

export default connect(mapStateToProps, {
  fetchFeature,
  fetchAllTickets,
  fetchStripeCurrency,
})(Tickets);
